import React, { useState } from "react";
import { RydProject } from "../../model/project";
import { useMixerStore } from "../../stores/MixerStore";
import { RydSaveProjectDialog } from "./RydSaveProjectDialog";
import { RydFeatures } from "../../utils/FeatureToggle";
import { normalizeClassName } from "../../render/renderUtils";
import { CaretController } from "../../utils/ScrollController";
import {
    useSetWorkspaceComputedContextFrame,
    useSetWorkspaceContextPlane,
    useSetWorkspaceLines,
    useSetWorkspaceTracks,
    useSetWorkspaceUIState
} from "../../stores/WorkspaceStore";
import { TrackNameDialog } from "./TrackNameDialog";
import {
    addChordLine,
    addContext,
    addEmptyHNC
} from "../../services/ProjectTracksService";
import { WorkspacePlaybackControls } from "../layouts/WorkspacePlaybackControls";
import { set } from "lodash";


export function ProjectMainOptions({
    project,
    toggleLibraryCollapse,
    toggleInspectorCollapse,
    toggleMixerCollapse,
    caretController
}: {
    project: RydProject,
    toggleLibraryCollapse: () => void,
    toggleInspectorCollapse: () => void,
    toggleMixerCollapse: () => void,
    caretController?: CaretController
}) {
    const setWorkspaceTracks = useSetWorkspaceTracks();
    const setWorkspaceContextPlane = useSetWorkspaceContextPlane();
    const setWorkspaceComputedContextFrame = useSetWorkspaceComputedContextFrame();
    const setWorkspaceLines = useSetWorkspaceLines();
    const mixerStore = useMixerStore();
    const setWorkspaceUIState = useSetWorkspaceUIState();

    const [projectName, setProjectName] = useState(project.name || 'Untitled');

    const setProject = (project: RydProject) => {
        setWorkspaceTracks(new Map(project.tracks));
        setWorkspaceContextPlane({ stateObject: project.contextFrame.grid });
        setWorkspaceComputedContextFrame(project.contextFrame.computed);
        setWorkspaceLines([...project.getAll()]);
    };

    return (
        <div className={normalizeClassName(["project-main-options", "ryd-toplevel-commands"])}>

            <TrackNameDialog
                label="Project"
                value={projectName}
                setValue={(newName) => {
                    project.name = newName || '';
                    setProjectName(project.name);
                }}
                readonly={false}
                extraCollapsedStyle={{
                    backgroundColor: 'var(--color-current-project-options-bg)',
                    color: 'var(--md-sys-color-on-primary-container)',
                    borderColor: 'transparent',
                    fontWeight: 'bold',
                    minWidth: 'calc(var(--pr-infobar-track-width) / 2)',
                    width: undefined
                }}
            />

            <RydSaveProjectDialog line={project} />
            <button disabled onClick={_ => addContext(project, setProject, setWorkspaceUIState)}>+ Context</button>
            <button onClick={_ => addChordLine(project, setProject, setWorkspaceUIState)}>+ Harmony</button>
            <button onClick={_ => addEmptyHNC(project, setProject, mixerStore, setWorkspaceUIState)}>+ Notes</button>
            <button disabled>+ Rhythm</button>

            <div style={{
                display: 'inline-block',
                right: '0px',
                position: 'absolute'
            }}>
                {RydFeatures.Toggle.isOn('INSPECTOR_PANEL') &&
                    <button onClick={toggleInspectorCollapse}>Inspector</button>}
                <button onClick={toggleMixerCollapse}>Mixer</button>
                <button onClick={toggleLibraryCollapse}>Library</button>
            </div>
            <WorkspacePlaybackControls
                project={project}
                caretController={caretController}
            />
        </div>
    );
}